import g from '#core/global';
import events from '#core/events';
import load from '#core/load';


const feed_$ = '[data-feed-items-per-page]';
const items_$ = ':scope > .feed__inner > .feed__items > *';
const load_more_$ = '.feed__load-more__button';
const initialized_attr = 'data-feed-pagination-initialized';

let has_click_listener = false;


const module = {
	init() {
		if (load.ran('feed')) return false;

		load.content(() => {
			initialize_feeds();
			assign_click_listener();
		});
		load.all(() => {
			initialize_feeds();
			assign_click_listener();
		});
	},
};

export default module;
module.init();


/**
 * Hide items beyond the first page and enable each feed's Load More button.
 */
function initialize_feeds() {
	document.querySelectorAll(`${feed_$}:not([${initialized_attr}])`).forEach($feed => {
		const items_per_page = get_items_per_page($feed);
		const $items = Array.from($feed.querySelectorAll(items_$));
		const $button = $feed.querySelector(load_more_$);

		$feed.setAttribute(initialized_attr, 'true');
		if (!$button || items_per_page < 1 || $items.length <= items_per_page) return;

		$items.slice(items_per_page).forEach($item => {
			$item.hidden = true;
		});
		$button.hidden = false;
	});
}


/**
 * Assign one delegated click listener for progressively paginated feeds.
 */
function assign_click_listener() {
	if (has_click_listener) return;

	document.addEventListener(g.click_e, e => {
		const $button = e.target.closest(load_more_$);
		if (!$button) return;

		const $feed = $button.closest(feed_$);
		if (!$feed) return;

		const items_per_page = get_items_per_page($feed);
		const $hidden_items = Array.from($feed.querySelectorAll(items_$)).filter($item => $item.hidden);
		$hidden_items.slice(0, items_per_page).forEach($item => {
			$item.hidden = false;
		});

		if ($hidden_items.length <= items_per_page) {
			$button.hidden = true;
		}

		window.dispatchEvent(new CustomEvent(events.global.reinitialize));
		window.dispatchEvent(new CustomEvent(events.global.recalculate));
	});

	has_click_listener = true;
}


/**
 * Get the configured page size for a feed.
 *
 * @param {Element} $feed Feed element.
 * @return {number}
 */
function get_items_per_page($feed) {
	return parseInt($feed.getAttribute('data-feed-items-per-page'), 10) || 0;
}
